import { service } from '../../../../helpers/http' 

export const ActionGetGroupIdentifiers = ({ dispatch }, payload) => { 
    return service({
        module: 'domainGroupIdentifier',
        action: 'getGroupIdentifiers',
        payload: payload
    })
}

export const ActionPostGroupIdentifiers = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupIdentifier',
        action: 'postGroupIdentifiers',
        payload: payload
    })
    
}

export const ActionPutGroupIdentifiers = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupIdentifier',
        action: 'putGroupIdentifiers',
        payload: payload
    })
    
}

export const ActionDeleteGroupIdentifiers = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupIdentifier',
        action: 'deleteGroupIdentifiers',
        payload: payload
    })
    
}
